import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    display: block;
    height: fit-content;
    width: 100%;
    margin: 24px 0;
`;

export const PreviewBlock = styled.div``;

export const ShowMore = styled.span<{ isDesc?: boolean }>`
    ${({ isDesc }) => isDesc
        ? `
        display: block;
        ${FONTS.MediumXS};
        margin-top: 8px;
        `
        : `
        ${FONTS.XS};
        margin-left: 8px;
        `
    };
    ${FONTS.MediumXS};
    color: ${COLORS.Link};
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        ${FONTS.MediumXXS};
    }
`;

export const ImageDisplay = styled.div<{ isFullWidth: boolean }>`
    justify-content: center;
    width: ${({ isFullWidth }) => isFullWidth ? '100%' : '420px'};
    height: 240px;
    
    img {
        height: 100%;
        width: 100%;
        border-radius: 24px;
        object-fit: ${({ isFullWidth }) => isFullWidth ? 'initial' : 'contain'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 150px;
        margin: 0 auto;
    }
`;

export const ImagesList = styled.div`
    align-content: flex-start;
    width: 54px;
    margin-left: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        margin-left: 0;
    }
`;

export const ImageItem = styled.div<{ isSelected: boolean }>`
    justify-content: center;
    width: 54px;
    height: 54px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    ${({ isSelected }) => isSelected ? `border: 2px solid ${COLORS.ButtonAccent};` : ''}
    &:not(:first-child) {margin-top: 8px;}

    img {
        height: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 8px;
        &:first-child {margin-top: 8px;}
    }
`;

export const DescBlock = styled.div`
    display: block;
    margin-top: 24px;
`;

export const DescTitle = styled.p`
    ${FONTS.H5};
    margin-bottom: 4px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 8px;
    }
`;

// @todo Нужно проработать этот вопрос с разных сторон и создать компонент под это, комплексно закрыть вопрос отображения данных от апи.
export const Text = styled.div<{ isExpanded: boolean }>`
    display: inline;
    color: ${COLORS.TextHint};
    ${FONTS.XS};
    height: ${({ isExpanded }) => isExpanded ? 'auto' : '60px'};
    overflow: hidden;
    * {
        padding: revert;
    }
    p div span {
        display: inline;
    }
    ul li {
        display: list-item;
        list-style: disc;
    }
    ol {
        display: list-item;
        list-style: decimal;
    }
`;

export const SpecsList = styled.div<{ isExpanded: boolean }>`
    display: block;
    width: 100%;
    height: ${({ isExpanded }) => isExpanded ? 'auto' : '60px'};
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: ${({ isExpanded }) => isExpanded ? 'auto' : '60px'};
    }
`;

export const SpecItem = styled.div`
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 4px;
    ${FONTS.XXS};

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 4px;
    }
`;

export const SpecRow = styled.div`
    position: relative;
    width: 50%;
    overflow: hidden;

    &:first-child:after {
        position: absolute;
        display: block;
        width: 100%;
        content: "";
        border-bottom: 1px dotted ${COLORS.TextHint};
        left: 0;
        bottom: 4px;
        z-index: 0;
    }
`;

export const SpecName = styled.span`
    position: relative;
    color: ${COLORS.TextHint};
    background-color: ${COLORS.BgMain};
    padding-right: 1px;
    z-index: 1;
`;

export const SpecValue = styled.span`
    color: ${COLORS.TextPrimary};
    width: 100%;
    margin-left: 2px;
`;
